export default __webpack_public_path__ + "static/media/ic_refresh_48px.18914f50.svg";